import { Routes, Route } from 'react-router-dom'; // React Router for routing
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext'; // Provides authentication context
import Home from './pages/Home'; // Home page component
import Courses from './pages/Courses'; // List of all courses
import CourseDetail from './pages/CourseDetail'; // Detailed view of a specific course
import ProfilePage from './pages/ProfilePage'; // User profile page
import ChatPage from './pages/ChatPage'; // Chat interface for a specific chat room
import SearchUsersPage from './pages/SearchUsersPage'; // Search page for teachers to find students
import CreateCoursePage from './pages/CreateCoursePage'; // Page to create a new course
import CreateDeadlinePage from './pages/CreateDeadlinePage'; // Page to create deadlines for courses
import ManageStudentsPage from './pages/ManageStudentsPage'; // Page to manage students in a course
import ConfirmDeleteCoursePage from './pages/ConfirmDeleteCoursePage'; // Confirmation page for deleting a course
import ProvideFeedbackPage from './pages/ProvideFeedbackPage'; // Page for students to provide feedback
import ViewFeedbackPage from './pages/ViewFeedbackPage'; // Page for teachers to view feedback
import PostStatusUpdates from './pages/PostStatusUpdates'; // Page for posting status updates
import ChatSelection from './pages/ChatSelection'; // Page to select a chat room
import UploadPhotoPage from './pages/UploadPhotoPage'; // Page for uploading profile photo
import LoginPage from './pages/LoginPage'; // Login page
import SignupPage from './pages/SignupPage'; // Signup page

function App() {
  return (
    // Wrap the entire app in AuthProvider to provide authentication context to all components
    <AuthProvider>
         {/* Toast container for all toast notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
      {/* Define all application routes */}
      <Routes>
        {/* Home page */}
        <Route path="/" element={<Home />} />

        {/* Courses pages */}
        <Route path="/courses" element={<Courses />} /> {/* List all courses */}
        <Route path="/courses/:id" element={<CourseDetail />} /> {/* Specific course detail */}

        {/* User profile page */}
        <Route path="/profile" element={<ProfilePage />} />

        {/* Chat pages */}
        <Route path="/chat/:slug" element={<ChatPage />} /> {/* Chat for a specific room */}
        <Route path="/chat" element={<ChatSelection />} /> {/* Chat room selection */}

        {/* User management pages */}
        <Route path="/search-users" element={<SearchUsersPage />} /> {/* Search students */}
        <Route path="/manage_students/:course_id" element={<ManageStudentsPage />} /> {/* Manage students in a course */}

        {/* Course management pages */}
        <Route path="/courses/create" element={<CreateCoursePage />} /> {/* Create new course */}
        <Route path="/create_deadline/:course_id" element={<CreateDeadlinePage />} /> {/* Create deadline for a course */}
        <Route path="/courses/delete/:course_id" element={<ConfirmDeleteCoursePage />} /> {/* Confirm course deletion */}

        {/* Feedback pages */}
        <Route path="/course/provide_feedback/:course_id" element={<ProvideFeedbackPage />} /> {/* Student feedback submission */}
        <Route path="/course/view_feedback/:course_id" element={<ViewFeedbackPage />} /> {/* Teacher view feedback */}

        {/* Status update page */}
        <Route path="/post-status-update/:course_id" element={<PostStatusUpdates />} /> {/* Post updates for a course */}

        {/* Profile photo upload page */}
        <Route path="/profile/upload-photo" element={<UploadPhotoPage />} />

        {/* Authentication pages */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App; // Export the App component as default
